export const DisableAccountsMessages = {
    AccountsForBlockingNotFound: {
        key: 'AccountsForBlockingNotFound',
        message: 'Should select any account for blocking first.'
    },
    BlockingAccountGroupFailed: {
        key: 'BlockingAccountFailed',
        message: 'Blocking of %%account%% failed.'
    },
    DisableAccountsSucceed: {
        key: 'DisableAccountsSucceed',
        message: 'All selected accounts are blocked successfully.'
    },
    DisableAccountsRequestsNotFound: {
        key: 'DisableAccountsRequestsNotFound',
        message: 'Can\'t create blocking requests. Data missing.'
    }
};
